import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "border-bottom": "none",
    "border-radius": "0"
  }
}, null, -1);
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  style: {
    "display": "flex",
    "gap": "6px"
  }
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = ["href"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "brand-name-and-asin-count"
};
const _hoisted_10 = {
  class: "brand-asin-count"
};
const _hoisted_11 = {
  key: 0,
  style: {
    "padding": "0px 8px",
    "display": "flex",
    "justify-content": "flex-end",
    "align-items": "center",
    "height": "100%"
  }
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center",
    "width": "100%",
    "justify-content": "center"
  }
};
const _hoisted_14 = {
  key: 0,
  class: "no-best-product-seller-rank"
};
const _hoisted_15 = {
  class: "popover-content"
};
const _hoisted_16 = {
  class: "name-and-category"
};
const _hoisted_17 = {
  class: "name"
};
const _hoisted_18 = {
  class: "category"
};
const _hoisted_19 = {
  class: "seller-price-vs-market-price"
};
const _hoisted_20 = {
  class: "seller-price"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "seller-price-label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot purple"
}), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("Avg. "), /*#__PURE__*/_createElementVNode("b", null, "seller"), /*#__PURE__*/_createTextVNode(" price")])], -1);
const _hoisted_22 = {
  class: "market-price"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "seller-price-label"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot red"
}), /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode("Avg. "), /*#__PURE__*/_createElementVNode("b", null, "market"), /*#__PURE__*/_createTextVNode(" price")])], -1);
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "versus"
}, "vs", -1);
const _hoisted_25 = {
  class: "market-price-range-popover-content"
};
const _hoisted_26 = {
  class: "range-bar-container"
};
const _hoisted_27 = {
  class: "min-max-market-price"
};
const _hoisted_28 = {
  class: "market-price min"
};
const _hoisted_29 = {
  class: "market-price max"
};
const _hoisted_30 = {
  class: "keys"
};
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_32 = {
  key: 0,
  class: "no-competitor"
};
const _hoisted_33 = {
  class: "popover-content"
};
const _hoisted_34 = {
  style: {
    "width": "100px",
    "padding": "0px 2px 0px 0px",
    "height": "20px",
    "display": "flex",
    "justify-content": "flex-end"
  }
};
const _hoisted_35 = ["src"];
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#F4F4F4'
  }
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_performance_product_table_group_by = _resolveComponent("performance-product-table-group-by");
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_performance_product_table_total = _resolveComponent("performance-product-table-total");
  const _component_chevron_down_icon = _resolveComponent("chevron-down-icon");
  const _component_chevron_right_icon = _resolveComponent("chevron-right-icon");
  const _component_value_element = _resolveComponent("value-element");
  const _component_marketplace_value = _resolveComponent("marketplace-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_product_value = _resolveComponent("product-value");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_brand_parent_value = _resolveComponent("brand-parent-value");
  const _component_hashed_number_value = _resolveComponent("hashed-number-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_segmented_bar = _resolveComponent("segmented-bar");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_image_element = _resolveComponent("image-element");
  const _component_dotted_position_bar = _resolveComponent("dotted-position-bar");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_evolution_arrow = _resolveComponent("evolution-arrow");
  const _component_range_bar = _resolveComponent("range-bar");
  const _component_text_value = _resolveComponent("text-value");
  const _component_bar_with_difference_from_max_marked = _resolveComponent("bar-with-difference-from-max-marked");
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_floating_compound_table = _resolveComponent("floating-compound-table");
  return _openBlock(), _createBlock(_component_floating_compound_table, {
    ref: "performanceFloatingCompoundTable",
    datePickerDate: $options.datePickerDate,
    loading: $props.loading,
    onChangeDate: $options.handleDatePickerSubmit,
    onTableState: $options.handleTableState,
    page: $options.page,
    "onUpdate:page": _cache[0] || (_cache[0] = $event => $options.page = $event),
    totalPages: $options.totalPages,
    "onUpdate:totalPages": _cache[1] || (_cache[1] = $event => $options.totalPages = $event),
    perPage: $options.perPage,
    "onUpdate:perPage": _cache[2] || (_cache[2] = $event => $options.perPage = $event),
    style: {
      ['--compound-table-right-gap']: '16px'
    },
    fields: $options.fields,
    selectedPeriod: _ctx.period
  }, {
    header: _withCtx(() => [_createTextVNode("Breakdown by")]),
    "header-sub": _withCtx(() => [_createVNode(_component_performance_product_table_group_by, {
      onRefresh: $options.handleGroupByRefresh,
      onClicked: $options.handleClicked,
      tabBusy: $props.loading
    }, null, 8, ["onRefresh", "onClicked", "tabBusy"])]),
    table: _withCtx(({
      fullSize,
      visible
    }) => [_createVNode(_component_b_table_lite, {
      class: _normalizeClass(['lite-table', 'market-insights-performance-product-table', {
        ['full-size']: fullSize
      }, {
        ['intermediate']: !fullSize && visible
      }, _ctx.groupBy]),
      style: _normalizeStyle(_ctx.cssProps),
      items: $options.filteredItems,
      fields: $options.fields,
      responsive: "",
      fixed: "",
      "sticky-header": "",
      bordered: "",
      "no-border-collapse": "",
      tbodyTrClass: item => $options.getTbodyTrClass(item),
      onHeadClicked: _ctx.handleHeadClick,
      onRowClicked: $options.handleRowClick,
      fieldColumnClass: field => $options.getThClass(field)
    }, _createSlots({
      "head()": _withCtx(col => [_createVNode(_component_flex_row, {
        styles: {
          justifyContent: col.field.justify,
          ...col.field.thStyle,
          textAlign: col.field.justify
        },
        id: `performance-product-table-${col?.column}-${_ctx.groupBy}`
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          triggers: "hover",
          target: `performance-product-table-${col?.column}-${_ctx.groupBy}`,
          style: {
            width: '100%'
          }
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
          }, null, 8, _hoisted_1)]),
          content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
          default: _withCtx(() => [_createElementVNode("div", {
            class: "title",
            innerHTML: col?.label
          }, null, 8, _hoisted_2)]),
          _: 2
        }, 1032, ["target"])]),
        _: 2
      }, 1032, ["styles", "id"])]),
      "custom-foot": _withCtx(() => [_createElementVNode("tr", null, [_createVNode(_component_performance_product_table_total, {
        fields: $options.fields,
        total: $options.total,
        currencyConfig: _ctx.currencyConfig,
        loading: $props.loading,
        evolutionType: _ctx.evolutionType
      }, null, 8, ["fields", "total", "currencyConfig", "loading", "evolutionType"])])]),
      "bottom-row": _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.fields, (field, index) => {
        return _openBlock(), _createElementBlock("td", {
          key: index,
          class: _normalizeClass(['bottom-row', {
            'b-table-sticky-column': field.stickyColumn
          }, field.class])
        }, _hoisted_4, 2);
      }), 128))]),
      "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
        style: {
          "cursor": "pointer"
        },
        class: "mi-brand-parent-arrow"
      }, {
        default: _withCtx(() => [!row.item?.is_child_asin ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_ctx.competitor_parents.get(row.item?.brand)?.collapsed ? (_openBlock(), _createBlock(_component_chevron_down_icon, {
          key: 0,
          class: "arrow",
          width: 20,
          height: 20
        })) : (_openBlock(), _createBlock(_component_chevron_right_icon, {
          key: 1,
          class: "arrow",
          width: 20,
          height: 20
        }))], 64)) : _createCommentVNode("", true)]),
        _: 2
      }, 1024)]),
      "cell(seller_name)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_value_element, {
          value: row.item?.seller_name
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(sales_channel)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_marketplace_value, {
          marketplace: $data.amz_sp_api_marketplace_ids_country_domains[$data.country_code_amz_sp_api_marketplace_ids[row.item?.country_code]],
          flag: _ctx.getCountryFlag(row.item?.country_code)
        }, null, 8, ["marketplace", "flag"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(category)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          class: "flag",
          src: _ctx.getCountryFlag(row.item?.country_code),
          alt: row.item?.country_code
        }, null, 8, _hoisted_6), _createVNode(_component_wrap_with_popover, {
          width: "fit-content",
          placement: "top"
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(row.item?.category_name), 1)]),
          default: _withCtx(() => [_createElementVNode("a", {
            class: "category_name",
            href: $options.formatLink(row.item?.category_link),
            target: "_blank"
          }, _toDisplayString(row.item?.category_name), 9, _hoisted_7)]),
          _: 2
        }, 1024)])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(category_revenue_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "right"
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.category_revenue_share,
          precision: row.item?.category_revenue_share >= 0.01 && row.item?.category_revenue_share < 0.05 ? 1 : 0,
          charCount: $options.minMax?.marketshare?.min <= 0.05 ? $options.maxCharCount?.percentage?.marketshare + 1 : $options.maxCharCount?.percentage?.marketshare,
          type: "market_insights_evol_table",
          style: {
            "justify-content": "flex-end"
          }
        }, null, 8, ["value", "precision", "charCount"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(brand)": _withCtx(row => [row.item?.is_child_asin ? (_openBlock(), _createBlock(_component_product_value, {
        key: 0,
        value: {
          name: row.item?.title,
          image: row.item?.image_link,
          asin: row.item?.asin,
          link: row.item?.amazon_link,
          image_channels: $options.getImageChannels(row.item?.amazon_links)
        },
        loading: $props.loading,
        styles: {
          padding: '4px 8px 4px 42px',
          height: 'fit-content'
        },
        isChild: true
      }, _createSlots({
        _: 2
      }, [_ctx.showParentViewAll(_ctx.competitor_parents, row.item, 'brand', 5) ? {
        name: "badge",
        fn: _withCtx(() => [_createElementVNode("div", {
          class: "view-all-toggle",
          onClick: $event => $options.toggleViewAll(row.item)
        }, [_createTextVNode(" View all "), _createVNode(_component_chevron_down_icon, {
          color: "#736BC9",
          width: 16,
          height: 16
        })], 8, _hoisted_8)]),
        key: "0"
      } : undefined]), 1032, ["value", "loading"])) : (_openBlock(), _createBlock(_component_brand_parent_value, {
        key: 1,
        value: {
          brand: row.item?.brand,
          image: row.item?.brand_logo_link ?? '/assets/images/empty-white.svg',
          image_size: 32
        },
        collapsed: _ctx.competitor_parents.get(row.item?.brand)?.collapsed,
        tagged: false,
        image_overlays: 1,
        onToggleChildren: $event => $options.handleRowClick(row.item),
        style: {
          padding: '4px 12px !important',
          gap: '12px !important'
        },
        class: "mi-brand-parent-value",
        custom: "",
        noArrow: ""
      }, {
        custom: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createTextVNode(_toDisplayString(row.item?.brand ?? 'Unbranded') + " ", 1), _createElementVNode("div", _hoisted_10, [_createVNode(_component_app_icon, {
          icon: "sub",
          size: 12
        }), _createTextVNode(" " + _toDisplayString(row.item?.asin_list?.length), 1)])])]),
        _: 2
      }, 1032, ["value", "collapsed", "onToggleChildren"]))]),
      "cell(competitor_seller_market_share_rank)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [!row.item?.is_child_asin ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 0,
          gap: 2,
          class: "competitor_rank_slot"
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`brand_rank_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_number_value, {
              value: row.item?.[`brand_rank_evol${$data.evolCategory[_ctx.periodCategory]}`] == 0 ? null : row.item?.[`brand_rank_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.maxCharCount?.number?.[`brand_rank_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: 0,
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_hashed_number_value, {
            value: row.item?.brand_rank,
            hashColor: "unset",
            charCount: $options.maxCharCount?.number?.brand_rank,
            style: {
              gap: '0px',
              padding: '4px',
              color: '#5A52AE'
            },
            class: _normalizeClass({
              'competitor_rank': row.item?.belongs_to_seller
            })
          }, null, 8, ["value", "charCount", "class"])]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(seller_market_share_rank)": _withCtx(row => [row.item?.seller_marketshare_rank == null ? (_openBlock(), _createElementBlock("div", _hoisted_11, " -- ")) : (_openBlock(), _createBlock(_component_hug_value, {
        key: 1,
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`seller_marketshare_rank_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_number_value, {
              value: row.item?.[`seller_marketshare_rank_evol${$data.evolCategory[_ctx.periodCategory]}`] == 0 ? null : row.item?.[`seller_marketshare_rank_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.maxCharCount?.number?.[`seller_marketshare_rank_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: 0,
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_hashed_number_value, {
            value: row.item?.seller_marketshare_rank,
            hashColor: "unset",
            style: {
              gap: '0px',
              width: '4ch'
            }
          }, null, 8, ["value"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"]))]),
      "cell(competitor_seller_market_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 0px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 16
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.marketshare,
            background: "",
            borderColor: "#CD93EB",
            min: 0,
            max: $options.minMax?.marketshare?.max,
            loading: $props.loading,
            align: "left",
            styles: {
              padding: 0
            },
            barStyles: {
              borderLeft: 'none',
              borderRight: 'none',
              borderRadius: '0px 64px 64px 0px',
              height: '45px',
              background: 'linear-gradient(270deg, #C5F3FC 20%, rgba(197, 243, 252, 0.10) 100%)'
            },
            class: _normalizeClass(['market_share_bar', _ctx.groupBy, {
              is_child: row.item?.is_child_asin
            }])
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.marketshare,
              precision: row.item?.marketshare >= 0.01 && row.item?.marketshare < 0.05 ? 1 : 0,
              charCount: $options.minMax?.marketshare?.min <= 0.05 ? $options.maxCharCount?.percentage?.marketshare + 1 : $options.maxCharCount?.percentage?.marketshare,
              type: "market_insights_evol_table",
              style: {
                "justify-content": "flex-start"
              }
            }, null, 8, ["value", "precision", "charCount"])]),
            _: 2
          }, 1032, ["value", "max", "loading", "barStyles", "class"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(seller_market_share)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 0px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 16
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.seller_marketshare,
            background: "",
            borderColor: "#CD93EB",
            min: 0,
            max: Math.max($options.minMax.seller_marketshare?.max, 0.1),
            loading: $props.loading,
            align: "left",
            styles: {
              padding: 0
            },
            barStyles: {
              borderLeft: 'none',
              borderRight: 'none',
              borderRadius: '0px 64px 64px 0px',
              height: '27px',
              background: row.item?.seller_marketshare == null ? 'linear-gradient(0deg, #000 0%, #000 100%), linear-gradient(270deg, #E5F7FA 20%, #FCFCFC 100%)' : 'linear-gradient(270deg, #C5F3FC 20%, rgba(197, 243, 252, 0.10) 100%)'
            },
            class: "market_share_bar"
          }, {
            default: _withCtx(() => [row.item?.seller_marketshare == null ? (_openBlock(), _createElementBlock("div", _hoisted_12, "--")) : (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: row.item?.seller_marketshare,
              precision: row.item?.seller_marketshare >= 0.01 && row.item?.seller_marketshare < 0.05 ? 1 : 0,
              charCount: $options.minMax?.seller_marketshare?.min <= 0.05 ? $options.maxCharCount?.percentage?.seller_marketshare + 1 : $options.maxCharCount?.percentage?.seller_marketshare,
              type: "market_insights_evol_table",
              style: {
                "justify-content": "flex-start"
              }
            }, null, 8, ["value", "precision", "charCount"]))]),
            _: 2
          }, 1032, ["value", "max", "loading", "barStyles"])]),
          _: 2
        }, [row.item?.seller_marketshare != null ? {
          name: "evolution",
          fn: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          key: "0"
        } : undefined]), 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(competitor_seller_share_of_units_sold)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 4px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            loading: $props.loading,
            tight: ""
          }, {
            "custom-bar": _withCtx(() => [_createVNode(_component_segmented_bar, {
              value: row.item?.share_of_units_sold ?? 0,
              color: "#669EFF",
              class: "competitor_share_of_units_sold_bar"
            }, null, 8, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.share_of_units_sold,
              styles: {
                padding: 0,
                textAlign: 'right'
              },
              charCount: $options.minMax?.share_of_units_sold?.min <= 0.05 ? $options.maxCharCount?.percentage?.share_of_units_sold + 1 : $options.maxCharCount?.percentage?.share_of_units_sold,
              precision: row.item?.share_of_units_sold >= 0.01 && row.item?.share_of_units_sold < 0.05 ? 1 : 0,
              type: "market_insights_evol_table",
              style: _normalizeStyle(row.item?.share_of_units_sold < 0.05 ? {
                gap: '2px',
                marginLeft: '-2px'
              } : {})
            }, null, 8, ["value", "charCount", "precision", "style"])]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(seller_share_of_units_sold)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 4px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, _createSlots({
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            loading: $props.loading,
            tight: ""
          }, {
            "custom-bar": _withCtx(() => [_createVNode(_component_segmented_bar, {
              value: row.item?.seller_share_of_units_sold ?? 0,
              color: row.item?.seller_share_of_units_sold == null ? '#E3E3E3' : '#669EFF'
            }, null, 8, ["value", "color"])]),
            default: _withCtx(() => [row.item?.seller_share_of_units_sold == null ? (_openBlock(), _createElementBlock("div", _hoisted_13, " -- ")) : (_openBlock(), _createBlock(_component_percentage_value, {
              key: 1,
              value: row.item?.seller_share_of_units_sold,
              styles: {
                padding: 0,
                textAlign: 'right'
              },
              charCount: $options.minMax?.seller_share_of_units_sold?.min <= 0.05 ? $options.maxCharCount?.percentage?.seller_share_of_units_sold + 1 : $options.maxCharCount?.percentage?.seller_share_of_units_sold,
              precision: row.item?.seller_share_of_units_sold >= 0.01 && row.item?.seller_share_of_units_sold < 0.05 ? 1 : 0,
              type: "market_insights_evol_table",
              style: _normalizeStyle(row.item?.seller_share_of_units_sold < 0.05 ? {
                gap: '2px',
                marginLeft: '-2px'
              } : {})
            }, null, 8, ["value", "charCount", "precision", "style"]))]),
            _: 2
          }, 1032, ["loading"])]),
          _: 2
        }, [row.item?.seller_share_of_units_sold != null ? {
          name: "evolution",
          fn: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          key: "0"
        } : undefined]), 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(best_seller_product_rank)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [row.item?.best_seller_product_rank == null ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No products in best-sellers ")) : (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 1,
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, null, {
            default: _withCtx(() => [_createVNode(_component_hashed_number_value, {
              value: row.item?.best_seller_product_rank,
              hashColor: "unset",
              style: {
                gap: '0px',
                width: '4ch'
              }
            }, null, 8, ["value"])]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.best_seller_product_rank ?? 0,
            color: "#9B94EB",
            loading: $props.loading,
            tight: ""
          }, {
            "custom-bar": _withCtx(() => [_createVNode(_component_dotted_position_bar, {
              value: row.item?.best_seller_product_rank ?? 0,
              color: "#9B94EB"
            }, null, 8, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
              width: "fit-content",
              placement: "top",
              customClass: "best-seller-product-popover"
            }, {
              content: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_image_element, {
                image: row.item?.best_seller_product_main_image_link,
                width: 40,
                height: 40,
                countryCode: row.item?.best_seller_product_country_code,
                withFlag: "",
                flagStyle: {
                  width: '23px !important',
                  height: '16px !important',
                  bottom: '-12px !important',
                  right: '8px !important'
                }
              }, null, 8, ["image", "countryCode"]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(row.item?.best_seller_product_product_title), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(row.item?.best_seller_product_category_name), 1)])])]),
              default: _withCtx(() => [_createVNode(_component_image_element, {
                image: row.item?.best_seller_product_main_image_link,
                width: 20,
                height: 20,
                link: row.item?.best_seller_product_link_to_amazon,
                countryCode: row.item?.best_seller_product_country_code,
                withOverlay: "",
                withFlag: ""
              }, null, 8, ["image", "link", "countryCode"])]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1032, ["value", "loading"])]),
          _: 2
        }, 1024))]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(market_size)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px 0px 0px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 4
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.market_size,
            background: "",
            borderColor: "#CD93EB",
            min: 0,
            max: $options.minMax?.market_size?.max,
            loading: $props.loading,
            align: "left",
            styles: {
              padding: 0
            },
            barStyles: {
              borderLeft: 'none',
              borderRight: 'none',
              borderRadius: '0px 64px 64px 0px',
              height: '28px',
              background: 'linear-gradient(270deg, #F3E5FA 20%, rgba(243, 229, 250, 0.10) 100%)'
            },
            class: "market_size_bar"
          }, {
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.market_size,
              allowPrecisionModification: false,
              charCount: $options.maxCharCount?.currency?.market_size,
              precision: row.item?.market_size > 1000000 ? 1 : 0
            }, null, 8, ["value", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value", "max", "loading", "barStyles"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(market_units_sold)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_bar_with_value, {
            value: row.item?.market_units_sold,
            min: 0,
            color: "#FFB17A",
            max: $options.minMax?.market_units_sold?.max,
            loading: $props.loading,
            tight: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.market_units_sold,
              styles: {
                padding: 0,
                textAlign: 'right'
              },
              charCount: $options.maxCharCount?.number?.market_units_sold
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "max", "loading"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(competitor_avg_market_price)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.avg_price,
            charCount: $options.maxCharCount?.currency?.avg_price + 1,
            precision: "1"
          }, null, 8, ["value", "charCount"])]),
          default: _withCtx(() => [_createVNode(_component_evolution_arrow, {
            value: row.item?.[`avg_price_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, null, 8, ["value"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(market_price_range)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        class: "market-price-range",
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          width: "fit-content",
          placement: "top",
          customClass: "market-price-range-popover"
        }, {
          content: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createVNode(_component_currency_value, {
            value: row.item?.avg_seller_price,
            precision: 1,
            class: "currency"
          }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createVNode(_component_currency_value, {
            value: row.item?.avg_market_price,
            precision: 1,
            class: "currency"
          }, null, 8, ["value"])]), _hoisted_24]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_range_bar, {
            min: Math.min(...[row.item?.min_market_price_range, row.item?.avg_seller_price, row.item?.avg_market_price].filter(v => v != null)),
            max: Math.max(...[row.item?.max_market_price_range, row.item?.avg_seller_price, row.item?.avg_market_price].filter(v => v != null)),
            range_min: row.item?.min_market_price_range,
            range_max: row.item?.max_market_price_range,
            values: [{
              value: row.item?.avg_market_price ?? 0,
              component: 'DotElement',
              color: '#F174AA',
              size: 8,
              zIndex: 1
            }, {
              value: row.item?.avg_seller_price ?? 0,
              component: 'DotElement',
              color: '#A666FF',
              size: 12
            }]
          }, null, 8, ["min", "max", "range_min", "range_max", "values"])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createTextVNode(" Market 1st decile "), _createVNode(_component_currency_value, {
            value: row.item?.p1_market_price_range,
            precision: 1,
            class: "currency"
          }, null, 8, ["value"])]), _createElementVNode("div", _hoisted_29, [_createTextVNode(" Market 9th decile "), _createVNode(_component_currency_value, {
            value: row.item?.p9_market_price_range,
            precision: 1,
            class: "currency"
          }, null, 8, ["value"])])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("span", null, [_createTextVNode("This range excludes extreme outliers "), _hoisted_31, _createTextVNode(" The full market range is "), _createVNode(_component_currency_value, {
            value: row.item?.min_market_price,
            precision: 1,
            class: "inline-currency"
          }, null, 8, ["value"]), _createTextVNode(" - "), _createVNode(_component_currency_value, {
            value: row.item?.max_market_price,
            precision: 1,
            class: "inline-currency"
          }, null, 8, ["value"])])])]),
          default: _withCtx(() => [_createVNode(_component_range_bar, {
            min: $options.minMax.min_market_price_range.min,
            max: $options.minMax.max_market_price_range.max,
            range_min: row.item?.min_market_price_range,
            range_max: row.item?.max_market_price_range,
            values: [{
              value: row.item?.avg_market_price ?? 0,
              component: 'DotElement',
              color: '#F174AA',
              size: 8,
              zIndex: 1
            }, {
              value: row.item?.avg_seller_price ?? 0,
              component: 'DotElement',
              color: '#A666FF',
              size: 12
            }]
          }, null, 8, ["min", "max", "range_min", "range_max", "values"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(relative_marketshare_to_top_competitor)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8,
          class: "relative-share"
        }, {
          evolution: _withCtx(() => [_createVNode(_component_bar_with_value, {
            loading: $props.loading,
            tight: "",
            reverse: "",
            class: "relative-share-bar top-competitor",
            style: _normalizeStyle({
              '--display-difference-bar': `${$options.minMax?.relative_marketshare_to_top_competitor?.max > 1 ? 'block' : 'none'}`,
              '--display-dashed-vertical-bar': `${$options.minMax?.relative_marketshare_to_top_competitor?.max > 1 ? 'block' : 'none'}`,
              '--display-max-dot': `${$options.minMax?.relative_marketshare_to_top_competitor?.max > 1 ? 'block' : 'none'}`
            })
          }, {
            "custom-bar": _withCtx(() => [_createVNode(_component_bar_with_difference_from_max_marked, {
              value: Math.round(row.item?.relative_marketshare_to_top_competitor * 10) / 10,
              color: "linear-gradient(90deg, #C7C2FC 56.55%, #FFF 100%)",
              max: $options.minMax?.relative_marketshare_to_top_competitor?.max > 1 ? $options.minMax?.relative_marketshare_to_top_competitor?.max : 1
            }, null, 8, ["value", "max"])]),
            "bar-append": _withCtx(() => [_hoisted_36, _createVNode(_component_dot_element, {
              size: 7,
              color: "#9B94EB",
              style: {
                "margin-right": "-3px",
                "z-index": "1",
                "align-self": "center"
              }
            })]),
            default: _withCtx(() => [_createVNode(_component_text_value, {
              value: row.item?.relative_marketshare_to_top_competitor ? 'x' + (Math.round(row.item?.relative_marketshare_to_top_competitor * 10) / 10).toFixed(1) : '--',
              styles: {
                textAlign: 'right',
                width: '4ch',
                alignContent: 'center'
              }
            }, null, 8, ["value"])]),
            _: 2
          }, 1032, ["loading", "style"])]),
          default: _withCtx(() => [row.item?.top_competitor == null ? (_openBlock(), _createElementBlock("div", _hoisted_32)) : (_openBlock(), _createBlock(_component_wrap_with_popover, {
            key: 1,
            width: "fit-content",
            placement: "top",
            customClass: "relative-share-popover"
          }, {
            content: _withCtx(() => [_createElementVNode("div", _hoisted_33, [row.item?.top_competitor_logo ? (_openBlock(), _createBlock(_component_image_element, {
              key: 0,
              image: row.item?.top_competitor_logo,
              width: 50,
              height: 50
            }, null, 8, ["image"])) : _createCommentVNode("", true), _createVNode(_component_text_value, {
              value: $options.capitalizeWords(row.item?.top_competitor.toLowerCase()),
              main: ""
            }, null, 8, ["value"])])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_34, [row.item?.top_competitor_logo ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: row.item?.top_competitor_logo,
              alt: "",
              style: {
                "cursor": "pointer",
                "align-self": "center",
                "max-height": "20px",
                "max-width": "100px"
              }
            }, null, 8, _hoisted_35)) : (_openBlock(), _createBlock(_component_text_value, {
              key: 1,
              value: $options.capitalizeWords(row.item?.top_competitor.toLowerCase()),
              main: "",
              styles: {
                cursor: 'pointer',
                width: 'unset'
              }
            }, null, 8, ["value"]))])]),
            _: 2
          }, 1024))]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(brand_revenue)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 4
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`brand_revenue_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`brand_revenue_evol${$data.evolCategory[_ctx.periodCategory]}`] == 0 ? null : row.item?.[`brand_revenue_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`brand_revenue_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`brand_revenue_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`brand_revenue_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`brand_revenue_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`brand_revenue_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.brand_estimated_revenue,
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.brand_estimated_revenue,
            align: "right",
            precision: row.item?.brand_estimated_revenue > 1000000 ? 1 : 0
          }, null, 8, ["value", "charCount", "precision"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(brand_units_sold)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "padding": "0px 8px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 4
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`brand_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`brand_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`] == 0 ? null : row.item?.[`brand_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: $options.minMax?.[`brand_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`brand_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`] + 3 : $options.maxCharCount?.percentage?.[`brand_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs(row.item?.[`brand_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`brand_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              align: "right",
              tight: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: row.item?.brand_estimated_units_sold,
            align: "right",
            tight: ""
          }, null, 8, ["value"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      _: 2
    }, [_ctx.groupBy !== 'competitor' ? {
      name: "thead-top",
      fn: _withCtx(() => [_createVNode(_component_b_tr, {
        class: "headers"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_th, {
          colspan: _ctx.groupBy === 'category' ? 2 : 1,
          "sticky-column": ""
        }, null, 8, ["colspan"]), _createVNode(_component_b_th, {
          colspan: "4",
          class: "seller_performance left-embrace right-embrace",
          style: {
            color: '#5100C2',
            backgroundColor: '#F8F5FF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Seller Performance")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_b_th, {
          colspan: "4",
          class: "market left-embrace right-embrace",
          style: {
            color: '#E16098',
            backgroundColor: '#FFF0F7'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode(" Estimated Best-Sellers Market")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]),
      key: "0"
    } : undefined]), 1032, ["class", "style", "items", "fields", "tbodyTrClass", "onHeadClicked", "onRowClicked", "fieldColumnClass"])]),
    _: 1
  }, 8, ["datePickerDate", "loading", "onChangeDate", "onTableState", "page", "totalPages", "perPage", "fields", "selectedPeriod"]);
}